import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './OpeningHoursBlock';

const OpeningHoursSuspense = dynamic(() => import('./OpeningHoursBlock'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicOpeningHours(props: Props) {
	return <OpeningHoursSuspense {...props} />;
}
DynamicOpeningHours.displayName = 'DynamicOpeningHours';
